import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ComponentizedEquipment} from '../shared/componentized-equipment.model';
import {MatDialog} from '@angular/material/dialog';
import {EquipmentDecomponentizationFormDialogComponent} from '../equipment-decomponentization-form-dialog/equipment-decomponentization-form-dialog.component';

@Component({
  selector: 'lib-item-summary-equipment-decomponentization-action',
  templateUrl: './equipment-decomponentization-action.component.html'
})
export class EquipmentDecomponentizationActionComponent implements OnInit, OnChanges {

  @Input() selectedItems: ComponentizedEquipment[] = [];
  @Input() hideButtonIfNotApplicable = false;
  @Output() refresh = new EventEmitter<boolean>();
  hint: string;
  shouldBeDisabled: boolean;
  private parentItem: ComponentizedEquipment;

  constructor(private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.handleSelectedItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedItems
      && !changes.selectedItems.isFirstChange()
      && changes.selectedItems.currentValue) {
      this.handleSelectedItems();
    }
  }

  private handleSelectedItems(): void {
    if (this.selectedItems.length === 0) {
      this.hint = 'No assets selected.';
      this.shouldBeDisabled = true;
      return;
    }

    if (this.selectedItems.length > 1) {
      this.hint = 'Only 1 asset can be decomponentized at a time.';
      this.shouldBeDisabled = true;
      return;
    }

    this.parentItem = this.selectedItems[0];
    if (this.parentItem.parentComponent) {
      const AUCTION_STATUS_SOLD = 3;
      if (this.parentItem.auctionStatusId === AUCTION_STATUS_SOLD) {
        this.hint = 'Sold & Collapsed assets cannot be de-componentized';
        this.shouldBeDisabled = true;
        return;
      } else {
        this.hint = '';
        this.shouldBeDisabled = false;
        return;
      }
    } else {
      this.hint = 'The selected asset is not a parent component.';
      this.shouldBeDisabled = true;
      return;
    }
  }

  openDecomponentizationDialog() {
    this.dialog.open(EquipmentDecomponentizationFormDialogComponent, {
        maxWidth: '600px',
        disableClose: true,
        data: {
          equipment: this.selectedItems[0]
        }
      })
      .afterClosed()
      .subscribe(result => {
        if (result === 'Done') {
          this.refresh.emit(true);
        }
      });
  }
}
